import React from 'react';
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import {RichText} from 'prismic-reactjs';
import CallToActionSection from "../sections/CallToActionSection";
import DownArrow from "../parts/DownArrow";
import {site} from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";


class ServicesPage extends React.Component {
  componentDidMount() {
    window.analytics.page("Services");
  }

  render() {
    window.prerenderReady = false;
    if (this.props.page && this.props.page.doc) {
      window.prerenderReady = true;
      const data = this.props.page.doc.data;
      return (
        <div className={'page-services'}>
          <Helmet>
            <title>{site.titlePrefix + 'Services'}</title>
            {metaTitles(site.titlePrefix + 'Services')}
            {metaDescriptions(RichText.asText(data.hero_message))}
          </Helmet>
          <section className={'hero'} id={'hero'}>
            <div className={'container'}>
              <h1 className={'title'}>{data.hero_title}</h1>
              <div className={'brief'}>{RichText.render(data.hero_message)}</div>
            </div>
            <DownArrow scrollPastId={'hero'}/>
          </section>
          <div className={'content'}>
            <section className={'approach'}>
              <div className={'container'}>
                <div className={'image'} data-aos="grid-fade-up"/>
                <div className={'text'} data-aos="grid-fade-up">
                  <h2 className={'title'}>{data.approach_title}</h2>
                  <div className={'brief'}>
                    {RichText.render(data.approach_brief)}
                  </div>
                </div>
              </div>
            </section>
            <section className={'services'}>
              <div className={'container'}>
                <ul className={'services'}>
                  {data.services.map((service) => (
                    <li key={service.title} data-aos="grid-fade-up">
                      <div className={'frame'}>
                        <img src={service.image.url} alt={service.image.alt}/>
                      </div>
                      <div className={'text'}>
                        <h2 className={'title'}>{service.title}</h2>
                        <div className={'description'}>
                          {RichText.render(service.description)}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
            <section className={'process'}>
              <div className={'container'} data-aos="grid-fade-up">
                <header>
                  <h2 className={'title'}>{data.process_title}</h2>
                  <div className={'subtitle'}>{data.process_subtitle}</div>
                </header>
                <div className={'brief'}>{RichText.render(data.process_brief)}</div>
                <div className={'image'}>
                  <img src={data.process_image.url} alt={data.process_image.alt}/>
                </div>
              </div>
            </section>
            <CallToActionSection/>
          </div>
        </div>
      )
    }

    return null;
  }
}


export default pageWithPrismic(ServicesPage, 'services_page');


// WEBPACK FOOTER //
// ./src/pages/ServicesPage.js